/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/components/notification/app.notification.list.component.ts.
 */
import {Component, OnInit} from '@angular/core';
import {Notification} from '../../models/notification';
import {User} from '../../models/user';
import {AppNotificationComponent} from './app.notification.component';

/**
 * Zweck: Beschreibt class AppNotificationListComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    templateUrl: 'app.notification.list.component.html',
    styleUrls: ['app.notification.list.component.scss'],
    standalone: false
})
export class AppNotificationListComponent extends AppNotificationComponent implements OnInit {
  static id = 'AppNotificationListComponent';
  user: User;

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    this.userService.user$.subscribe((user: User) => {
      this.user = user;
    });

    this.fetch();
  }

/**
 * Beschreibt Methode fetch und ihren Rückgabevertrag.
 */
  fetch() {
    this.loader.start('NotificationlistComponent_1');
    this.notificationService.getAll().subscribe(n => {
      this.notifications.next(n);
      this.loader.stop('NotificationlistComponent_1');
    });

  }


/**
 * Beschreibt Methode isCurrentUser und ihren Rückgabevertrag.
 */
  isCurrentUser(testuser: User) {
    let state = false;

    if (testuser.id && this.user instanceof User && testuser.id == this.user.id) {
      state = true;
    }

    return state;
  }


/**
 * Beschreibt Methode setSeen und ihren Rückgabevertrag.
 */
  setSeen(event: Event, notification: Notification): void {
    event.stopImmediatePropagation();
    this.notificationService.setSeen(notification.id).subscribe(state => {
      this.fetch();
    });
  }

/**
 * Beschreibt Methode navigateSeen und ihren Rückgabevertrag.
 */
  navigateSeen(notification: Notification, url = '') {
    this.notificationService.setSeen(notification.id).subscribe(state => {
      if (url != '') {
        this.notificationService.addNotificationData(url, notification);

        this.router.navigateByUrl(url);
      } else {
        this.fetch();
      }
    });
  }
}
